import React, { useState } from "react";

const AddBreakDetailsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [addBreakDetailsPopup, setaddBreakDetailsPopup] =
      useState<boolean>(false);

    const addBreakDetailsToggleHandler = () => {
      setaddBreakDetailsPopup(!addBreakDetailsPopup);
    };

    return (
      <Component
        addBreakDetailsPopup={addBreakDetailsPopup}
        addBreakDetailsToggleHandler={addBreakDetailsToggleHandler}
        {...props}
      />
    );
  };

export default AddBreakDetailsPopupHOC;
